import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarTenagaKesehatanDetail from "../../components/TopBarTenagaKesehatanDetail";
import AktivitasTenagaKesehatan from "../../components/AktivitasTenagaKesehatan";
import "../../CSS/ProfileTenagaKesehatan.css";

function HalamanProfileTenagaKesehatan() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarTenagaKesehatanDetail />

        {/* Konten utama */}
        <div className="main-contentprofile">
          <AktivitasTenagaKesehatan />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanProfileTenagaKesehatan;
